// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CloudUploadIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "CloudUpload/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 17a5 5 0 0 1-.916-9.916 5.002 5.002 0 0 1 9.832 0A5.002 5.002 0 0 1 16 17m-7-5 3-3m0 0 3 3m-3-3v12"
}));
export default CloudUploadIcon;